<template>
  <div>
    <el-form
      v-if="creativeForm.delivery_mode"
      ref="formRef"
      :model="creativeForm"
      :rules="rules"
      @submit.native.prevent
      class="creative-config-form"
      label-width="130px"
    >
      <Divider title="创意形式"></Divider>
      <CreativeTemplateForm
        v-model="creativeForm"
        :planForm="planForm"
        @creative-template-change="onCreativeTemplateChange"
      ></CreativeTemplateForm>

      <Divider title="营销组件"></Divider>
      <CreativeTemplateComponents v-model="creativeForm" :planForm="planForm" :accounts="configForm.accounts">
        <!-- 标签选择 -->
        <template v-slot:labelbtns>
          <template v-if="creativeForm.components.label && creativeForm.components.label.length">
            <el-button type="text" @click="labelModal = true"> 修改标签 </el-button>
            <el-button type="text" @click="onClearRemove"> 清空 </el-button>
          </template>
          <el-button type="text" @click="labelModal = true" v-else> +新增标签 </el-button>
        </template>

        <!-- 图文链接创意图片 -->
        <template v-slot:minicardimage>
          <el-avatar
            @click.native="showIconSelector(SELECTOR_TYPE.MINI_CARD_LINK)"
            shape="square"
            :size="100"
            fit="contain"
            :src="creativeForm.components.mini_card_link.mini_card_link_image.url"
          >
            <em class="el-icon-plus"></em>
          </el-avatar>
        </template>

        <!-- 浮层卡片创意图片 -->
        <template v-slot:floatingzoneimage>
          <el-avatar
            @click.native="showIconSelector(SELECTOR_TYPE.FLOATING_ZONE)"
            shape="square"
            :size="100"
            fit="contain"
            :src="creativeForm.components.floating_zone.floating_zone_image.url"
          >
            <em class="el-icon-plus"></em>
          </el-avatar>
        </template>

        <!-- 自定义创意手动匹配的试玩页结束页图片 -->
        <template v-slot:wxgameplayable>
          <el-image
            @click.native="showWxgamePlayableSelector('')"
            style="width: 128px; height: 100px"
            :src="creativeForm.components.wxgame_playable_page.wxgame_playable_page_end_cover_img.url"
            fit="contain"
          >
            <template #error>
              <div class="image-error-placeholder">
                <em class="el-icon-plus"></em>
              </div>
            </template>
          </el-image>
        </template>

        <!-- 组件化创意自动匹配的试玩页图片 -->
        <template v-slot:wxgameplayableimage>
          <el-image
            @click.native="showWxgamePlayableImageSelector"
            style="width: 100px; height: 100px"
            :src="creativeForm.components.wxgame_playable_component.card_link_image.url"
            fit="contain"
          >
            <template #error>
              <div class="image-error-placeholder">
                <em class="el-icon-plus"></em>
              </div>
            </template>
          </el-image>
        </template>

        <!-- 组件化创意自动匹配的试玩页结束页图片 -->
        <template v-slot:wxgameplayableendimage>
          <el-image
            @click.native="showWxgamePlayableEndImageSelector"
            style="width: 128px; height: 100px"
            :src="creativeForm.components.wxgame_playable_component.end_cover_img.url"
            fit="contain"
          >
            <template #error>
              <div class="image-error-placeholder">
                <em class="el-icon-plus"></em>
              </div>
            </template>
          </el-image>
        </template>
      </CreativeTemplateComponents>
    </el-form>

    <!-- 选择标签 -->
    <LabelModal v-model="labelModal" :max="3" @on-select="onConfirmLabels"></LabelModal>

    <AssetsSelectorModal
      :visible.sync="selectorModal"
      v-bind="{ ...selectorProps }"
      @close="onSelectorClose"
      @confirm="onIconSelectorConfirm"
    >
      <template v-slot:assetType="{ getData }">
        <el-radio
          v-if="selectorFlag === SELECTOR_TYPE.WXGAME_PLAYABLE"
          v-model="selectorProps.assetType"
          @change="getData"
          :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
        >
          图片
        </el-radio>
        <el-radio v-model="selectorProps.assetType" @change="getData" :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO]"> LOGO </el-radio>
      </template>

      <template v-slot:sizes="{ getData, width }">
        <el-select
          :style="{ width }"
          popper-class="creative-selector-el-select-popper"
          :popper-append-to-body="false"
          v-model="selectorProps.form.size"
          clearable
          @change="getData"
        >
          <el-option
            v-for="item in MATERIAL_TYPE_SIZES_V3[selectorProps.assetType]"
            :key="item.label"
            :label="item.label"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </template>
    </AssetsSelectorModal>
  </div>
</template>

<script setup>
import { ref, inject, unref, computed, nextTick } from 'vue'
import Divider from '@/views/create/bytedance/components/layout/title-divider.vue'
import LabelModal from '@/views/create/gdt/components/creative/label.vue'
import AssetsSelectorModal from '@/components/material-selector/index.js'
// 创意形式
import CreativeTemplateForm from './components/creative-form/creative-form-template.vue'
// 创意组件
import CreativeTemplateComponents from './components/creative-form/creative-form-components.vue'

import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import {
  useIconSelector,
  useMiniCardLink,
  useLabel,
  useFloatingZone,
  useWxgamePlayableCustom,
  useWxgamePlayableComponent
} from '../../hooks/useGdtCreativeForm.js'
import { creativeFormV3Rules } from '@/views/create/gdt/model/creative-rules.js'
import { MATERIAL_TYPE_SIZES_V3, MATERIAL_SIZES } from '@/views/create/gdt/model/creative-const.js'

const { configForm } = inject('configForm')
const formRef = ref(null)
const creativeForm = ref({})
const planForm = computed(() => configForm.value.planForm)
const rules = computed(() => creativeFormV3Rules.call({ group: creativeForm.value, planForm: planForm.value }))

const { SELECTOR_TYPE, selectorModal, selectorFlag, wxgamePlayableFlag, selectorProps, showIconSelector, onSelectorClose } =
  useIconSelector()
// 图文链接
const { onMiniCardLinkSelectorConfirm } = useMiniCardLink(creativeForm)
// 标签
const { labelModal, onConfirmLabels, onClearRemove } = useLabel(creativeForm)
// 浮层卡片
const { onFloatingZoneSelectorConfirm } = useFloatingZone(creativeForm)
// 自定义创意手动匹配的试玩页
const { onWxgamePlayableSelectorConfirm } = useWxgamePlayableCustom(creativeForm)

// 组件化创意自动匹配的试玩页营销组件
const { onWxgamePlayableCompSelectorConfirm } = useWxgamePlayableComponent(creativeForm)

function onCreativeTemplateChange() {
  nextTick(() => {
    formRef.value?.clearValidate()
  })
}

function showWxgamePlayableSelector() {
  selectorProps.value.form.size = MATERIAL_SIZES.SIZE_1280_720
  showIconSelector(SELECTOR_TYPE.WXGAME_PLAYABLE)
}

function showWxgamePlayableImageSelector() {
  selectorProps.value.form.size = MATERIAL_SIZES.SIZE_800_800
  selectorProps.value.assetType = MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]
  showIconSelector(SELECTOR_TYPE.WXGAME_PLAYABLE, 'card_link_image')
}

function showWxgamePlayableEndImageSelector() {
  selectorProps.value.form.size = MATERIAL_SIZES.SIZE_1280_720
  selectorProps.value.assetType = MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]
  showIconSelector(SELECTOR_TYPE.WXGAME_PLAYABLE, 'end_cover_img')
}

function onIconSelectorConfirm(assets) {
  if (selectorFlag.value === SELECTOR_TYPE.MINI_CARD_LINK) {
    onMiniCardLinkSelectorConfirm(assets)
  } else if (selectorFlag.value === SELECTOR_TYPE.FLOATING_ZONE) {
    onFloatingZoneSelectorConfirm(assets)
  } else if (selectorFlag.value === SELECTOR_TYPE.WXGAME_PLAYABLE) {
    if (wxgamePlayableFlag.value) {
      onWxgamePlayableCompSelectorConfirm(assets, wxgamePlayableFlag.value)
    } else {
      onWxgamePlayableSelectorConfirm(assets)
    }
  }
  onSelectorClose()
}
// eslint-disable-next-line
defineExpose({
  setForm: (form) => {
    creativeForm.value = form
  },
  getForm: () => unref(creativeForm),
  validate: async () => {
    return formRef.value.validate()
  }
})
</script>

<style lang="scss" scoped>
::v-deep .image-error-placeholder {
  background: #c0c4cc;
  color: #fff;
  border-radius: 4px;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
}
</style>
